import React from 'react'
import { Card, Input, Space, Button, Select, Spin } from 'antd'
import { SearchOutlined, PlusOutlined } from '@ant-design/icons'
import { useBrands } from '../hooks/useBrands'
import { useBrandActions } from '../hooks/useBrandActions'
import { BrandsTable } from '../components/BrandsTable'
import { BrandDetailsDrawer } from '../components/BrandDetailsDrawer'
import { BrandFormModal } from '../components/BrandFormModal'

const { Option } = Select

export const BrandsScreen: React.FC = () => {
    const {
        brands,
        searchText, setSearchText,
        statusFilter, setStatusFilter,
        isLoading,
        isFetching
    } = useBrands()

    const {
        selectedBrand,
        isDetailDrawerOpen,
        isFormModalOpen,
        editingBrand,
        handleViewDetails,
        handleAddBrand,
        handleEditBrand,
        handleDeleteBrand,
        handleFormSubmit,
        closeDrawer,
        closeFormModal
    } = useBrandActions()

    return (
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
            <Card>
                <Space style={{ marginBottom: 16 }}>
                    <Input
                        placeholder="Search brands..."
                        prefix={<SearchOutlined />}
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        style={{ width: 300 }}
                    />
                    <Select
                        placeholder="Filter by status"
                        style={{ width: 150 }}
                        value={statusFilter}
                        onChange={setStatusFilter}
                    >
                        <Option value="all">All Status</Option>
                        <Option value="active">Active</Option>
                        <Option value="inactive">Inactive</Option>
                    </Select>
                    <Button type="primary" icon={<PlusOutlined />} onClick={handleAddBrand}>
                        Add Brand
                    </Button>
                </Space>

                <Spin spinning={isLoading || isFetching}>
                    <BrandsTable
                        brands={brands}
                        onRowClick={handleViewDetails}
                        onEdit={handleEditBrand}
                        onDelete={handleDeleteBrand}
                    />
                </Spin>
            </Card>

            <BrandDetailsDrawer
                brand={selectedBrand}
                open={isDetailDrawerOpen}
                onClose={closeDrawer}
                onEdit={handleEditBrand}
                onDelete={handleDeleteBrand}
            />

            <BrandFormModal
                open={isFormModalOpen}
                onCancel={closeFormModal}
                onSubmit={handleFormSubmit}
                initialValues={editingBrand}
            />
        </Space>
    )
}
